import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  OnDestroy,
  viewChild,
} from '@angular/core';
import { EventInput } from '@fullcalendar/core';
import { Draggable } from '@fullcalendar/interaction';
import { DragDropModule } from 'primeng/dragdrop';

@Component({
  standalone: true,
  selector: 'kon-resource-calendar-unscheduled-card',
  imports: [CommonModule, DragDropModule],
  template: ` @if (event(); as event) {
    <a
      #card
      class="fc-event fc-event-draggable event-card block w-full md:rounded-r-xl my-2 p-1 overflow-hidden"
      [ngStyle]="{
        'background-color': event.backgroundColor,
        color: event.textColor,
        'border-color': event.borderColor,
      }"
      [id]="event.extendedProps?.['entity']?.id"
    >
      <ng-content />
    </a>
    }`,
  styles: `
    :host .fc-event {
      border: solid;
      border-width: 0 0 0 3px;
      font-size: var(--fc-small-font-size);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceCalendarUnscheduledCardComponent implements OnDestroy {
  event = input.required<EventInput>();
  private card = viewChild<ElementRef<HTMLElement>>('card');
  private draggable: any = null;

  ngOnDestroy(): void {
    this.draggable?.destroy();
  }

  constructor() {
    effect(() => {
      this.draggable?.destroy();
      const cardEl = this.card();
      if (cardEl) {
        this.draggable = new Draggable(cardEl.nativeElement, {
          eventData: {
            duration: '02:00',
            ...this.event(),
          },
        });
      }
    });
  }
}
